import { UserPermissions } from '@centecomm/portal-service';
import { FeatureConfiguration } from 'Core/Types/FeatureConfiguration';
import FaqNavigationIcon from 'Icons/NavigationItem/FAQ';
import React from 'react';
import { LoadingContent } from 'Shared/PageElements/LoadingContent';

const LazyHelpGuidesSettingsPage = React.lazy(() => import('./Pages'));

const helpGuidesSettingsConfiguration: FeatureConfiguration = {
    name: 'administrationFeature:system.helpGuides.title',
    navigationItem: {
        route: {
            text: 'administrationFeature:sidebar.system.helpGuides.title',
            url: '/help-guides-settings',
            Icon: FaqNavigationIcon,
            ownerOperatorRoot: (
                <React.Suspense fallback={<LoadingContent />}>
                    <LazyHelpGuidesSettingsPage />
                </React.Suspense>
            ),
            tenantRoot: null,
        },
        isGloballyAccessible: false,
        permissions: [UserPermissions.ManageAdminConfig],
    },
    disableFeature: [],
};

export default helpGuidesSettingsConfiguration;
